import { videoSpecOptions } from 'client/constants/videoSpecOptions';
import { useTranslation } from 'react-i18next';

export const useVideoDetails = () => {
  const [t] = useTranslation();
  const { cinematicStyleOptions, musicTypeOptions, videoTypeOptions } = videoSpecOptions(t);

  return { t, cinematicStyleOptions, musicTypeOptions, videoTypeOptions };
};
